export default function LoadingTdmTable() {
  return (
    <>
      <table>
        <tbody>
          {[1, 2, 3, 4, 5].map((num) => (
            <tr key={num} className="animate-pulse">
              <td className="px-6 py-4 whitespace-nowrap w-1/3">
                <div className="h-2 w-1/3">
                  <div className="h-1 w-full rounded-md bg-neutralColor-light mb-2"></div>
                  <div className="h-1 w-1/2 rounded-md bg-neutralColor-light"></div>
                </div>
              </td>
              <td className="whitespace-nowrap w-60 text-center">
                <span className="-ml-10 h-4 w-1/3 inline-flex rounded-full bg-neutralColor-light"></span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap w-1/5">
                <div className="flex items-center">
                  <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-neutralColor-light">
                    <span className="font-medium leading-none text-green-500 font-bold"></span>
                  </span>
                  <div className="ml-4 h-2 w-1/3">
                    <div className="h-1 w-full rounded-md bg-neutralColor-light mb-2"></div>
                    <div className="h-1 w-1/2 rounded-md bg-neutralColor-light"></div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap w-1/5">
                <div className="flex items-center">
                  <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-neutralColor-light">
                    <span className="font-medium leading-none text-green-500 font-bold"></span>
                  </span>
                  <div className="ml-4 h-2 w-1/3">
                    <div className="h-1 w-full rounded-md bg-neutralColor-light mb-2"></div>
                    <div className="h-1 w-1/2 rounded-md bg-neutralColor-light"></div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap w-full">
                <div className="h-1 w-1/3 rounded-md bg-neutralColor-light mb-2"></div>
                <div className="h-1 w-1/2 rounded-md bg-neutralColor-light"></div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap w-full">
                <div className="h-1 rounded-md bg-neutralColor-light mb-2"></div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <div className="block h-1 w-16 rounded-md bg-neutralColor-light mb-2"></div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap w-full">
                <div className="h-1 w-1/3 rounded-md bg-neutralColor-light mb-2"></div>
                <div className="h-1 w-1/2 rounded-md bg-neutralColor-light"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
